import {
  ADD_UPDATE_CONFIGURATION_DETAILS_FAILURE,
  ADD_UPDATE_CONFIGURATION_DETAILS_REQUEST,
  ADD_UPDATE_CONFIGURATION_DETAILS_SUCCESS,
  GET_CONFIGURATION_DETAILS_FAILURE,
  GET_CONFIGURATION_DETAILS_REQUEST,
  GET_CONFIGURATION_DETAILS_SUCCESS,
} from "./actionTypes";
import { ConfigurationState } from "./types";

const initialState: ConfigurationState = {
  loading: false,
  error: null,
  successMessage: "",
  configurationDetails: null,
  pending: false
};

const configurationReducer = (
  state = initialState,
  action: any
): ConfigurationState => {
  switch (action.type) {
    case GET_CONFIGURATION_DETAILS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case GET_CONFIGURATION_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        configurationDetails: action.payload.configurationDetails,
      };

    case GET_CONFIGURATION_DETAILS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case ADD_UPDATE_CONFIGURATION_DETAILS_REQUEST:
      return {
        ...state,
        pending: true,
        error: null,
      };

    case ADD_UPDATE_CONFIGURATION_DETAILS_SUCCESS:
      return {
        ...state,
        pending: false,
        successMessage: action.payload.successMessage,
      };

    case ADD_UPDATE_CONFIGURATION_DETAILS_FAILURE:
      return {
        ...state,
        pending: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default configurationReducer;
